import { styleTags, tags as t } from '@lezer/highlight';

export const geoscriptHighlighting = styleTags({
  Identifier: t.variableName,
  GlobalIdentifier: t.standard(t.variableName),
  'CallExpr/Identifier': t.function(t.variableName),
  'CallExpr/GlobalIdentifier': t.function(t.standard(t.variableName)),
  'ClosureParamList/Identifier': t.function(t.definition(t.variableName)),
  'TypeHint/Identifier': t.typeName,
  'StaticFieldAccessExpr/Identifier': t.propertyName,
  LineComment: t.lineComment,
  Integer: t.integer,
  HexInteger: t.integer,
  Float: t.float,
  BoolLiteral: t.bool,
  NilLiteral: t.null,
  'StringLiteral/...': t.typeName, // default gruvbox theme makes strings white which I don't like
  '"+"': t.arithmeticOperator,
  '"-"': t.arithmeticOperator,
  '"/"': t.arithmeticOperator,
  '"%"': t.arithmeticOperator,
  '"||"': t.logicOperator,
  '"&&"': t.logicOperator,
  NullishOp: t.logicOperator,
  '"&"': t.bitwiseOperator,
  '"|"': t.bitwiseOperator,
  '"^"': t.bitwiseOperator,
  '">="': t.compareOperator,
  '"<="': t.compareOperator,
  '"=="': t.compareOperator,
  CompareOp: t.compareOperator,
  '"!="': t.compareOperator,
  '">"': t.compareOperator,
  '"<"': t.compareOperator,
  '"="': t.definitionOperator,
  '".."': t.punctuation,
  '"..="': t.punctuation,
  '( )': t.paren,
  '[ ]': t.squareBracket,
  '{ }': t.brace,
  ',': t.separator,
  ';': t.separator,
  If: t.keyword,
  ElseIf: t.keyword,
  Else: t.keyword,
  Return: t.keyword,
  Break: t.keyword,
  Path: t.keyword,
  Import: t.keyword,
  Export: t.keyword,
  From: t.keyword,
});
